import React from 'react';
import { useNavigate } from 'react-router-dom';
import './StaticPages.css';

export default function TestimonialsPage() {
  const navigate = useNavigate();
  return (
    <div className="static-page" data-testid="testimonials-page"><header className="static-header">
        <div className="container">
          <div className="header-content">
            <img src="/logo.png" alt="House Sharing Seniors" className="logo-image" onClick={() => navigate('/')} />
            <nav>
              <button className="btn btn-secondary" onClick={() => navigate('/properties')}>Browse Properties</button>
              <button className="btn btn-primary" onClick={() => navigate('/apply')}>Apply Now</button>
            </nav>
          </div>
        </div>
      </header>

      <section className="page-hero">
        <div className="container">
          <h1>Member Testimonials</h1>
          <p>Real stories from HSS members who found affordable, companionable shared housing.</p>
        </div>
      </section>

      <section className="page-content">
        <div className="container">
          <div style={{ textAlign: 'center', padding: '60px 20px', background: '#f8fafb', borderRadius: '16px', marginBottom: '32px' }}>
            <div style={{ fontSize: '64px', marginBottom: '20px' }}>⭐</div>
            <h2 style={{ color: '#1a2332', marginBottom: '12px' }}>Testimonials Coming Soon</h2>
            <p style={{ color: '#6b7280', maxWidth: '500px', margin: '0 auto 24px', lineHeight: '1.7' }}>
              We are collecting real stories from our members. As HSS grows and members settle into their new homes, we will share their experiences here.
            </p>
            <p style={{ color: '#6b7280', fontSize: '14px', marginBottom: '28px' }}>
              Are you an HSS member? We would love to hear your story.
            </p>
            <a href="mailto:feedback@housesharingseniors.com.au"
              style={{ display: 'inline-block', padding: '12px 28px', background: '#1a2332', color: 'white', borderRadius: '8px', fontWeight: '700', textDecoration: 'none', fontSize: '15px' }}>
              Share Your Story →
            </a>
          </div>

          <div style={{ textAlign: 'center' }}>
            <p style={{ color: '#6b7280', marginBottom: '16px' }}>In the meantime, see how HSS works:</p>
            <button className="btn btn-primary btn-large" onClick={() => navigate('/apply')}>Start Your Application</button>
          </div>
        </div>
      </section>

      <footer className="static-footer">
        <div className="container">
          <p>&copy; 2026 House Sharing Seniors. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}
